export const providers = {
  NOW_HEALTH_US: 'UNITED_HEALTHCARE',
  NOW_HEALTH_GLOBAL: 'NOW_HEALTH_GLOBAL',
  VUMI_BASIC_FLEX: 'VUMI_BASIC_FLEX',
  VUMI_VIP: 'VUMI_VIP',
  VUMI_INDIVIDUALS: 'VUMI_INDIVIDUALS',
  UNITED_HEALTHCARE: 'UNITED_HEALTHCARE',
  STANDARD_OLD: 'STANDARD_OLD'
};

export const PLAN_TYPES = {
  COMPANY_FMU: 'COMPANY_FMU',
  COMPANY_MHD: 'COMPANY_MHD',
  COMPANY_INDIVIDUAL_PLAN_ADMIN: 'COMPANY_INDIVIDUAL_PLAN_ADMIN',
  SOLO_INDIVIDUAL: 'SOLO_INDIVIDUAL'
};

export const ADDONS = [
  'DENTAL',
  'DEDUCTIBLE',
  'OUTPATIENT',
  'MATERNITY',
  'SCREENING',
  'VISION'
];

export const COMPANY_PLAN_TYPES = {
  STANDARD: 'STANDARD',
  PREMIUM: 'PREMIUM',
  MATERNITY: 'MATERNITY',
  STANDARD_EXTENDED: 'STANDARD_EXTENDED',
  AFFINITY_STANDARD: 'AFFINITY_STANDARD',
  AFFINITY_PREMIUM: 'AFFINITY_PREMIUM',
  AFFINITY_MATERNITY: 'AFFINITY_MATERNITY',
  AFFINITY_OLD: 'AFFINITY_OLD',
  INDIVIDUAL_STANDARD: 'INDIVIDUAL_STANDARD',
  INDIVIDUAL_PREMIUM: 'INDIVIDUAL_PREMIUM',
  INDIVIDUAL_MATERNITY: 'INDIVIDUAL_MATERNITY'
};

export const PROVIDERS = [
  'NOW_HEALTH_US',
  'UNITED_HEALTHCARE',
  'NOW_HEALTH_GLOBAL',
  'VUMI_VIP',
  'VUMI_BASIC_FLEX',
  'VUMI_INDIVIDUALS',
  ...Object.values(COMPANY_PLAN_TYPES)
];
